"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const grid_1 = __importDefault(require("components/templates/grid"));
const hopper_control_line_style_1 = __importDefault(require("../hopper-control-line.style"));
const input_1 = require("components/atoms/input");
const hopper_control_line_action_1 = __importDefault(require("../hopper-control-line.action"));
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const authorization_1 = require("utils/authorization");
const hopper_control_line_column_1 = require("../hopper-control-line.column");
const modal_1 = require("components/molecules/modal");
const svg_1 = require("components/atoms/svg");
const debounces_1 = require("utils/debounces");
const HopperConfig = () => {
    const { isError, dataGrid, dataBrand, dataDumping, dataDropdown, dataItem, isLoading, isSuccess, dataStates, errorMessage, } = (0, store_1.useAppSelector)((state) => state.configuration.hopperConfig);
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const debounceCallback = (0, debounces_1.useDebouncedCallback)((newDataStates) => {
        dispatch(hopper_control_line_action_1.default.getDataGrid(newDataStates));
    }, 1000, [dispatch]);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Configuration', 'Hopper');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                dispatch(hopper_control_line_action_1.default.getDataBrand());
                dispatch(hopper_control_line_action_1.default.getDataEnumDumping());
                dispatch(hopper_control_line_action_1.default.getDataGrid(dataStates));
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, fullScreen]);
    const iconColor = appTheme === 'dark' ? '#fff' : '#424242';
    const actionCellRender = (0, custom_cell_grid_1.actionCellInline)({
        type: 'other',
        permission: isAuthorized.change,
        iconEdit: (0, jsx_runtime_1.jsx)(svg_1.EditIcon, { color: iconColor }),
        iconSave: (0, jsx_runtime_1.jsx)(svg_1.SaveIcon, { color: iconColor }),
        iconCancel: (0, jsx_runtime_1.jsx)(svg_1.CancelIcon, { color: iconColor }),
        onCancel: (rowItem) => {
            const newDataGrid = dataGrid.map((item) => (Object.assign(Object.assign({}, item), { inEdit: false, isDisabled: false })));
            dispatch(hopper_control_line_action_1.default.onEnterEditClick({
                dataBrand,
                dataItem: rowItem,
                dataGrid: newDataGrid,
                mutationMode: false,
            }));
        },
        onSaveItem: (rowItem) => {
            const payload = Object.assign(Object.assign({}, dataItem), { id: rowItem.id });
            dispatch(hopper_control_line_action_1.default.onSaveDataItem({ dataItem: payload, mutationMode: 'edit', isSuccess: false }));
        },
        onEnterEdit: (rowItem) => {
            const newDataGrid = dataGrid.map((item) => item.checkpoint_id === rowItem.checkpoint_id
                ? Object.assign(Object.assign({}, item), { inEdit: true, isDisabled: false }) : Object.assign(Object.assign({}, item), { inEdit: false, isDisabled: true }));
            dispatch(hopper_control_line_action_1.default.onEnterEditClick({
                dataBrand,
                dataItem: rowItem,
                dataGrid: newDataGrid,
                mutationMode: 'edit',
            }));
        },
    });
    const actionColumn = [
        {
            title: '',
            width: '70px',
            sortable: false,
            filterable: false,
            show: isAuthorized.change,
            cell: actionCellRender,
            locked: true,
        },
    ];
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(hopper_control_line_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(hopper_control_line_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        debounceCallback(newDataStates);
    };
    const onSortChange = (e) => {
        dispatch(hopper_control_line_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        debounceCallback(newDataStates);
    };
    const _getDropdownValue = (field, data) => {
        return field === 'brand1_name'
            ? data.brand1_data || data.brand1_name
            : field === 'brand2_name'
                ? data.brand2_data || data.brand2_name
                : field === 'brand3_name'
                    ? data.brand3_data || data.brand3_name
                    : field === 'dumping_type'
                        ? data.dumping_data
                        : '';
    };
    const _getColumnValue = (field, data) => {
        console;
        return field === 'brand1_name'
            ? data.brand1_name
            : field === 'brand2_name'
                ? data.brand2_name
                : field === 'brand3_name'
                    ? data.brand3_name
                    : field === 'dumping_type'
                        ? data.dumping_type
                        : '';
    };
    const _getDisableStatus = (field, data) => {
        return field === 'brand2_name' ? data.brand2_disabled : field === 'brand3_name' ? data.brand3_disabled : false;
    };
    const customCellDropdown = ({ dataItem: rowData, dataIndex, field }) => {
        return rowData.inEdit ? ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `m_grid_cell_is_active_${dataIndex}` }, { children: (0, jsx_runtime_1.jsx)(input_1.Dropdown, { name: field, style: hopper_control_line_style_1.default.dropdownStyle(appTheme), value: _getDropdownValue(field, dataItem), disabled: _getDisableStatus(field, dataItem), textField: field === 'dumping_type' ? 'value' : 'name', dataItemKey: field === 'dumping_type' ? 'value' : 'name', data: field === 'dumping_type' ? dataDumping : dataDropdown, onChange: (e) => {
                    const value = e.target.value;
                    const brand = value;
                    const dumping = value;
                    const newDataItem = Object.assign(Object.assign({}, dataItem), { brand1_name: field === 'brand1_name' ? brand.name : dataItem.brand1_name, brand2_name: field === 'brand2_name' ? brand.name : dataItem.brand2_name, brand3_name: field === 'brand3_name' ? brand.name : dataItem.brand3_name, dumping_type: field === 'dumping_type' ? dumping.value : dataItem.dumping_type, brand2_disabled: field === 'brand1_name' ? false : dataItem.brand2_disabled, brand3_disabled: field === 'brand2_name' ? false : dataItem.brand3_disabled, brand1_data: field === 'brand1_name' ? e.target.value : dataItem.brand1_data, brand2_data: field === 'brand2_name' ? e.target.value : dataItem.brand2_data, brand3_data: field === 'brand3_name' ? e.target.value : dataItem.brand3_data, dumping_data: field === 'dumping_type' ? e.target.value : dataItem.dumping_data });
                    dispatch(hopper_control_line_action_1.default.onClickMutation({ mutationMode: 'edit', dataItem: newDataItem }));
                } }) }))) : ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `m_grid_cell_is_active_${dataIndex}` }, { children: _getColumnValue(field, rowData) })));
    };
    const columnsRender = actionColumn
        .concat(fullScreen ? hopper_control_line_column_1.HopperCLColumnPropsFullScreen : hopper_control_line_column_1.HopperCLColumnProps)
        .map((item) => {
        var _a;
        if (((_a = item.field) === null || _a === void 0 ? void 0 : _a.includes('brand')) || item.field === 'dumping_type') {
            return Object.assign(Object.assign({}, item), { cell: customCellDropdown });
        }
        return item;
    });
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, isLoading: isLoading, title: 'Hopper Control Line' }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(hopper_control_line_action_1.default.getDataGrid(dataStates));
                    dispatch(hopper_control_line_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { zIndex: 10 }, errorMessage: errorMessage, onClose: () => dispatch(hopper_control_line_action_1.default.onCloseError()) }), (0, jsx_runtime_1.jsx)(grid_1.default, { pageable: true, sortable: true, editField: 'inEdit', dataGrid: dataGrid, sort: dataStates.sort, columns: columnsRender, fullScreen: fullScreen, dataStates: dataStates, style: hopper_control_line_style_1.default.gridHeight, onSortChange: onSortChange, onFilterChange: onFilterChange, onPageChange: (v) => onDataStateChange('page', v), onTakeChange: (v) => onDataStateChange('take', v) })] }));
};
exports.default = HopperConfig;
